import React, { useState, useEffect } from "react";
import { sunIcon, moonIcon } from "assets";
import Icon from "components/Icon";

// Компонент переключення тем
const ThemeToggle = () => {
  // Функція для визначення початкової теми
  const getInitialTheme = () => {
    const savedTheme = localStorage.getItem("app-theme");
    if (savedTheme) {
      return savedTheme; // Повертаємо те, що юзер вибрав раніше
    }
    // Якщо збереженої немає — беремо системну
    const prefersDark = window.matchMedia("(prefers-color-scheme: dark)").matches;
    return prefersDark ? "dark" : "light";
  };

  const [isDark, setIsDark] = useState(() => getInitialTheme() === "dark");

  useEffect(() => {
    // Встановлюємо правильний атрибут при завантаженні
    const currentTheme = isDark ? "dark" : "light";
    document.documentElement.setAttribute("data-theme", currentTheme);
  }, [isDark]);

  const toggleTheme = () => {
    const newTheme = isDark ? "light" : "dark";
    setIsDark(!isDark);
    document.documentElement.setAttribute("data-theme", newTheme);
    // Зберігаємо вибір, щоб системна тема більше його не перебивала
    localStorage.setItem("app-theme", newTheme);
  };

  return (
    <button onClick={toggleTheme} className="theme-toggle-btn" title="Перемкнути тему">
      <div className="icon-bg-circle">
        <Icon src={isDark ? moonIcon : sunIcon} />
      </div>
    </button>
  );
};

export default ThemeToggle;
